import { render, staticRenderFns } from "./ReportImageDriversLicense.vue?vue&type=template&id=7c261a4b&scoped=true&"
import script from "./ReportImageDriversLicense.vue?vue&type=script&lang=ts&"
export * from "./ReportImageDriversLicense.vue?vue&type=script&lang=ts&"
import style0 from "./ReportImageDriversLicense.vue?vue&type=style&index=0&id=7c261a4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c261a4b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
